// import React, { Component } from 'react';
// // import '../bratilius-theme-package/assets-minified/all-demo.css'
// import '../CSS/assets-minified/all-demo.css'
// // import '../CSS/css/bootstrap.css'
// import Cookies from 'universal-cookie';
// import Dashboard from './Dashboard'
// import Login from './Login';

// class Splash extends Component{

//     constructor(props){
//         super(props)
//         this.state={
//             isLoggedin:false
//         }
//     }

//     componentWillMount =() => {
//         const cookies = new Cookies();
//         var loginStatus = cookies.get('loggedIn')
//         //(loginStatus)
//         if (loginStatus === 'true'){
//             this.setState({
//                 isLoggedin:true
//             })
//         }
//     }

//     render = () => {
//         if (this.state.isLoggedin === true){
//             return(
//                 <div >
//                     <Dashboard />
//                 </div>
//             )
//         }
//         else{
//             return(
//                 <div id="loading">
//                     <Login />
//                 </div>
//             )
//         }
//     }
// }

// export default Splash

import React from 'react'
import Cookies from 'universal-cookie'
import '../CSS/assets-minified/all-demo.css'
import Dashboard from './Dashboard'
import Login from './Login'

const Splash = () => {
    // Check if user has been logged in
    const [isLoggedIn, setIsLoggedIn] = React.useState(false)
    const checkLoggedIn = () => {
        const cookies = new Cookies()
        const token = cookies.get('token')
        setIsLoggedIn(token)
    }

    // Run the loggedin check
    React.useEffect(() => {
        checkLoggedIn()
    }, [])

    // Conditionally return based on whether logged in status
    return <div>{isLoggedIn ? <Dashboard /> : <Login />}</div>
}

export default Splash



// WEBPACK FOOTER //
// src/Routes/Splash.js